import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from '~/assets/icons';
import { IUser } from '~/utils/interface/user';

type BasicInfoUserDialogProps = {
  open: boolean;
  data?: {
    user?: IUser;
    password?: string;
  };
  setOpen?: (open: boolean, needRefreshData?: boolean) => void;
};

const BasicInfoUserDialog = (props: BasicInfoUserDialogProps) => {
  const { t } = useTranslation('admin/user');

  const handleSetOpen = (open: boolean, needRefreshData?: boolean) => {
    if (props.setOpen) {
      props.setOpen(open, needRefreshData);
    }
  };

  return (
    <>
      <Dialog open={props.open} onClose={() => handleSetOpen(false)} fullWidth maxWidth='sm'>
        <DialogTitle className='bg-[#ED1002]'>
          {t('basicInfo.title')}
          <IconButton onClick={() => handleSetOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography className='bg-[#005F73] p-3 rounded-[4px] text-white font-bold text-[15px] mb-4'>
            {t('basicInfo.notify')}
          </Typography>
          <Typography className='text-[#005F73] mb-2.5 font-bold'>{t('basicInfo.name')}</Typography>
          <Box className='flex  mb-2.5'>
            <Box className='font-bold basis-10'>{t('basicInfo.name2')}:</Box>
            <Box className='font-normal'>{props.data?.user?.name}</Box>
          </Box>
          <Box className='flex mb-2.5'>
            <Box className='font-bold basis-10'>{t('basicInfo.phone')}:</Box>
            <Box className='font-normal'>{props.data?.user?.phone}</Box>
          </Box>
          <Typography className='text-[#005F73] mb-2.5 font-bold'>{t('basicInfo.account')}</Typography>
          <Box className='flex mb-2.5'>
            <Box className='font-bold basis-32'>{t('basicInfo.username')}:</Box>
            <Box className='font-normal'>{props.data?.user?.username}</Box>
          </Box>
          <Box className='flex'>
            <Box className='font-bold basis-36'>{t('basicInfo.password')}:</Box>
            <Box className='font-normal'>{props.data?.password}</Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default memo(BasicInfoUserDialog);
